import React from 'react';

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  handleReload = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          height: '100dvh', padding: 32, textAlign: 'center', background: 'var(--color-bg)',
        }}>
          <p style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Etwas ist schiefgelaufen</p>
          <p style={{ fontSize: 14, color: 'var(--color-text-muted)', marginBottom: 20 }}>
            Die App hat einen Fehler erkannt.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: '10px 24px', borderRadius: 10, border: 'none',
              background: 'var(--color-accent)', color: '#fff', fontSize: 15, fontWeight: 600, cursor: 'pointer',
            }}
          >
            Neu laden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
